module.exports = __webpack_public_path__ + "media/images/icon_plus-d714b36b4c67b474f6a8fd332920dc09.svg";